(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sns-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sns-hero-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('sns-hero-slider')) return;

  class SNSHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.slides = Array.from(this.querySelectorAll('[data-sns-slide]'));
      this.prevButton = this.querySelector('[data-sns-prev]');
      this.nextButton = this.querySelector('[data-sns-next]');
      this.goButtons = Array.from(this.querySelectorAll('[data-sns-go]'));
      this.pauseButton = this.querySelector('[data-sns-pause]');
      this.status = this.querySelector('[data-sns-status]');
      this.currentCounter = this.querySelector('[data-sns-current]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.intervalMs = Math.max(1000, Number(this.dataset.interval || 4000));
      this.firstInteractionDelay = this.dataset.firstInteractionDelay || 'immediately';
      this.duration = Math.max(0, Number(this.dataset.duration || 450));
      this.effect = this.dataset.effect || 'slide_horizontal';
      this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.pauseOffscreen = this.dataset.pauseOffscreen === 'true';
      this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.userPaused = false;
      this.hoverPaused = false;
      this.offscreenPaused = false;
      this.hiddenPaused = document.hidden;
      this.transitioning = false;
      this.timer = null;
      this.autoplayArmed = false;
      this._autoplayInteractionHandler = null;
      this.touchStart = null;

      this.prevButton?.addEventListener('click', () => this.previous(true));
      this.nextButton?.addEventListener('click', () => this.next(true));
      this.goButtons.forEach((button) => button.addEventListener('click', () => {
        const targetIndex = Number(button.dataset.snsGo);
        if (!this.transitioning && targetIndex !== this.index && this.slides[targetIndex]) {
          /* SNS V5.2: give immediate visual feedback on dot/number click.
             The indicator becomes active as soon as the click is accepted,
             while the banner image completes its normal manual transition. */
          this.updateControls(targetIndex);
        }
        this.goTo(targetIndex, 1, true);
      }));
      this.pauseButton?.addEventListener('click', () => this.togglePause());

      this.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true });
      this.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => { this.hoverPaused = true; this.clearTimer(); });
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; this.schedule(); });
        this.addEventListener('focusin', () => { this.hoverPaused = true; this.clearTimer(); });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) { this.hoverPaused = false; this.schedule(); }
        });
      }

      this._visibilityHandler = () => {
        this.hiddenPaused = document.hidden;
        if (this.hiddenPaused) this.clearTimer(); else this.schedule();
        if (!document.hidden) this.playActiveVideo(); else this.pauseAllVideos();
      };
      document.addEventListener('visibilitychange', this._visibilityHandler);

      if (this.pauseOffscreen && 'IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.offscreenPaused = !entry || entry.intersectionRatio < 0.15;
          if (this.offscreenPaused) {
            this.clearTimer();
            this.pauseAllVideos();
          } else {
            this.hydrateAround(this.index);
            this.playActiveVideo();
            this.schedule();
          }
        }, { threshold: [0, 0.15, 0.5] });
        this._observer.observe(this);
      }

      this.hydrateMedia(this.index);
      this.playActiveVideo();
      this.deferNeighborHydration();
      this.updateControls();

      /* SNS V5.6 — protect initial LCP.
         No automatic slide change happens before the visitor's first real
         pointer or keyboard interaction. */
      if (this.autoplayEnabled && !this.reduceMotion) this.armAutoplayAfterFirstInteraction();
    }

    disconnectedCallback() {
      this.clearTimer();
      this._observer?.disconnect();
      this.removeAutoplayInteractionListeners();
      if (this._visibilityHandler) document.removeEventListener('visibilitychange', this._visibilityHandler);
    }

    armAutoplayAfterFirstInteraction() {
      if (!this.autoplayEnabled || this.reduceMotion || this.autoplayArmed || this._autoplayInteractionHandler) return;

      this._autoplayInteractionHandler = () => {
        if (this.autoplayArmed) return;
        this.autoplayArmed = true;
        this.removeAutoplayInteractionListeners();
        this.startAutoplayAfterInteraction();
      };

      /* First genuine visitor interaction only:
         - mouse/touch/stylus press via pointerdown
         - mouse wheel / trackpad gesture via wheel
         - keyboard interaction via keydown (arrows, PageDown, Space, etc.)

         IMPORTANT: do NOT use the generic "scroll" event here.
         Browsers, restoration logic, accessibility tools and Lighthouse/PageSpeed
         can generate scroll events without a real visitor interaction, which can
         arm autoplay during performance measurement and create a late LCP candidate. */
      window.addEventListener('pointerdown', this._autoplayInteractionHandler, { capture: true, passive: true });
      window.addEventListener('wheel', this._autoplayInteractionHandler, { capture: true, passive: true });
      window.addEventListener('keydown', this._autoplayInteractionHandler, { capture: true });
    }

    removeAutoplayInteractionListeners() {
      if (!this._autoplayInteractionHandler) return;
      window.removeEventListener('pointerdown', this._autoplayInteractionHandler, true);
      window.removeEventListener('wheel', this._autoplayInteractionHandler, true);
      window.removeEventListener('keydown', this._autoplayInteractionHandler, true);
      this._autoplayInteractionHandler = null;
    }

    startAutoplayAfterInteraction() {
      this.clearTimer();

      if (this.firstInteractionDelay === 'immediately') {
        this.next(false);
        return;
      }

      let wait = this.intervalMs;
      if (this.firstInteractionDelay === '0.4') wait = 400;
      else if (this.firstInteractionDelay === '1') wait = 1000;
      else if (this.firstInteractionDelay === '2') wait = 2000;
      else if (this.firstInteractionDelay === 'normal_interval') wait = this.intervalMs;

      this.timer = window.setTimeout(() => {
        this.timer = null;
        if (this.isPaused()) {
          this.schedule();
          return;
        }
        this.next(false);
      }, wait);
    }

    isPaused() {
      return !this.autoplayEnabled || !this.autoplayArmed || this.reduceMotion || this.userPaused || this.hoverPaused || this.offscreenPaused || this.hiddenPaused;
    }

    clearTimer() {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
    }

    schedule() {
      this.clearTimer();
      if (this.isPaused() || this.slides.length < 2) return;

      const active = this.slides[this.index];
      if (active?.dataset.mediaType === 'video' && active.dataset.videoAdvance === 'video_end') {
        const video = active.querySelector('video');
        if (video) {
          video.loop = false;
          video.onended = () => {
            video.onended = null;
            if (!this.isPaused()) this.next(false);
          };
          return;
        }
      }

      this.timer = window.setTimeout(() => this.next(false), this.intervalMs);
    }

    next(manual = false) { this.goTo((this.index + 1) % this.slides.length, 1, manual); }
    previous(manual = false) { this.goTo((this.index - 1 + this.slides.length) % this.slides.length, -1, manual); }

    async goTo(targetIndex, direction = 1, manual = false) {
      if (manual && this.autoplayEnabled && !this.reduceMotion && !this.autoplayArmed) {
        this.autoplayArmed = true;
        this.removeAutoplayInteractionListeners();
      }

      if (this.transitioning || targetIndex === this.index || !this.slides[targetIndex]) {
        if (manual) this.schedule();
        return;
      }

      this.clearTimer();
      const from = this.slides[this.index];
      const to = this.slides[targetIndex];
      this.hydrateMedia(targetIndex);
      this.transitioning = true;

      this.pauseVideo(from);
      to.classList.add('is-transitioning');
      to.setAttribute('aria-hidden', 'false');

      /* SNS V5.4 — honor the selected transition effect and duration everywhere.
         V5/V5.3 forced autoplay to a 120 ms fade, so the admin's Effect and
         Transition speed settings appeared not to work during normal autoplay. */
      const duration = this.reduceMotion ? 0 : this.duration;
      if (duration > 0 && to.animate && from.animate) {
        const frames = this.framesForEffect(direction);
        const options = { duration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' };
        const fromAnimation = from.animate(frames.out, options);
        const toAnimation = to.animate(frames.in, options);
        try { await Promise.all([fromAnimation.finished, toAnimation.finished]); } catch (e) {}
        fromAnimation.cancel();
        toAnimation.cancel();
      }

      from.classList.remove('is-active');
      from.setAttribute('aria-hidden', 'true');
      to.classList.remove('is-transitioning');
      to.classList.add('is-active');
      this.index = targetIndex;
      this.transitioning = false;

      this.updateControls();
      this.playActiveVideo();
      this.hydrateAround(this.index);
      if (this.status && manual) this.status.textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
      this.schedule();
    }

    framesForEffect(direction) {
      const sign = direction >= 0 ? 1 : -1;
      switch (this.effect) {
        case 'fade':
          return { out: [{ opacity: 1 }, { opacity: 0 }], in: [{ opacity: 0 }, { opacity: 1 }] };
        case 'slide_down':
          return {
            out: [{ transform: 'translate3d(0,0,0)', opacity: 1 }, { transform: `translate3d(0,${100 * sign}%,0)`, opacity: 1 }],
            in: [{ transform: `translate3d(0,${-100 * sign}%,0)`, opacity: 1 }, { transform: 'translate3d(0,0,0)', opacity: 1 }]
          };
        case 'slide_up':
          return {
            out: [{ transform: 'translate3d(0,0,0)', opacity: 1 }, { transform: `translate3d(0,${-100 * sign}%,0)`, opacity: 1 }],
            in: [{ transform: `translate3d(0,${100 * sign}%,0)`, opacity: 1 }, { transform: 'translate3d(0,0,0)', opacity: 1 }]
          };
        case 'zoom_fade':
          return {
            out: [{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(.985)', opacity: 0 }],
            in: [{ transform: 'scale(1.035)', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }]
          };
        case 'slide_horizontal':
        default:
          return {
            out: [{ transform: 'translate3d(0,0,0)', opacity: 1 }, { transform: `translate3d(${-100 * sign}%,0,0)`, opacity: 1 }],
            in: [{ transform: `translate3d(${100 * sign}%,0,0)`, opacity: 1 }, { transform: 'translate3d(0,0,0)', opacity: 1 }]
          };
      }
    }

    hydrateMedia(index) {
      const slide = this.slides[index];
      if (!slide || slide.dataset.hydrated === 'true') return;

      slide.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
        if (source.dataset.sizes) source.sizes = source.dataset.sizes;
        source.removeAttribute('data-srcset');
        source.removeAttribute('data-sizes');
      });

      slide.querySelectorAll('img[data-src]').forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.sizes) img.sizes = img.dataset.sizes;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-sizes');
      });

      const template = slide.querySelector('template[data-sns-video-template]');
      const shell = slide.querySelector('[data-sns-media-shell]');
      if (template && shell && !shell.querySelector('video')) {
        shell.appendChild(template.content.cloneNode(true));
        const video = shell.querySelector('video');
        if (video) {
          video.muted = true;
          video.playsInline = true;
          video.preload = 'metadata';
          video.addEventListener('playing', () => shell.classList.add('is-playing'));
          video.addEventListener('pause', () => { if (video.currentTime === 0) shell.classList.remove('is-playing'); });
        }
      }

      slide.dataset.hydrated = 'true';
    }

    hydrateAround(index) {
      this.hydrateMedia((index + 1) % this.slides.length);
      if (this.slides.length > 2) {
        window.setTimeout(() => this.hydrateMedia((index - 1 + this.slides.length) % this.slides.length), 800);
      }
    }

    deferNeighborHydration() {
      const work = () => this.hydrateAround(this.index);
      if ('requestIdleCallback' in window) window.requestIdleCallback(work, { timeout: 1400 });
      else window.setTimeout(work, 700);
    }

    playActiveVideo() {
      const slide = this.slides[this.index];
      if (!slide || slide.dataset.mediaType !== 'video' || this.offscreenPaused || document.hidden) return;
      this.hydrateMedia(this.index);
      const video = slide.querySelector('video');
      if (!video) return;
      const finishMode = slide.dataset.videoAdvance === 'video_end';
      video.loop = finishMode ? false : slide.dataset.videoLoop === 'true';
      const playPromise = video.play();
      if (playPromise?.catch) playPromise.catch(() => {});
      if (finishMode) this.schedule();
    }

    pauseVideo(slide) {
      const video = slide?.querySelector('video');
      if (!video) return;
      video.onended = null;
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
      slide.querySelector('[data-sns-media-shell]')?.classList.remove('is-playing');
    }

    pauseAllVideos() { this.slides.forEach((slide) => this.pauseVideo(slide)); }

    updateControls(displayIndex = this.index) {
      this.goButtons.forEach((button) => {
        const active = Number(button.dataset.snsGo) === displayIndex;
        button.setAttribute('aria-current', active ? 'true' : 'false');
        button.querySelector('.sns-hero__dot')?.classList.toggle('is-active', active);
        button.classList.toggle('is-active', active);
      });
      if (this.currentCounter) this.currentCounter.textContent = String(displayIndex + 1);
    }

    togglePause() {
      this.userPaused = !this.userPaused;
      if (this.pauseButton) {
        this.pauseButton.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
      }
      if (this.userPaused) this.clearTimer(); else this.schedule();
    }

    onTouchStart(event) {
      if (!event.touches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      this.touchStart = { x: touch.clientX, y: touch.clientY, time: Date.now() };
    }

    onTouchEnd(event) {
      if (!this.touchStart || !event.changedTouches || event.changedTouches.length !== 1) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - this.touchStart.x;
      const dy = touch.clientY - this.touchStart.y;
      const elapsed = Date.now() - this.touchStart.time;
      this.touchStart = null;
      if (elapsed > 800 || Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
      if (dx < 0) this.next(true); else this.previous(true);
    }
  }

  customElements.define('sns-hero-slider', SNSHeroSlider);

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-sns-slide]');
    const slider = slide?.closest?.('sns-hero-slider');
    if (!slide || !slider) return;
    slider.userPaused = true;
    slider.clearTimer();
    slider.goTo(Number(slide.dataset.index), 1, true);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
